
/* eslint-disable @typescript-eslint/no-shadow */
export namespace ReportType {
  export enum ReportType {
    CODED = "CODED",
    NON_CODED = "NON_CODED",
  }

  export interface ReportTypeDTO {
    case: string;
  }

  export const fromDTO = (dto: ReportTypeDTO): ReportType => {
    if (dto === undefined || dto === null) {
      throw new InvalidReportTypeError(
        `Invalid DTO ${dto} provided for ReportType.ReportType`
      );
    }
    switch (dto.case) {
      case "CODED":
        return ReportType.CODED;
      case "NON_CODED":
        return ReportType.NON_CODED;
      default:
        throw new InvalidReportTypeError(
          `Case ${dto.case} is not valid case of ReportType.ReportType`
        );
    }
  };

  export const toDTO = (reportType: ReportType): ReportTypeDTO => {
    const enumDTO = {
      case: ReportType[reportType],
    };
    return enumDTO;
  };
}

export class InvalidReportTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidReportTypeError";
  }
}
export class InvalidReportTypeCodedError extends InvalidReportTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidReportTypeCodedError";
  }
}

export class InvalidReportTypeNonCodedError extends InvalidReportTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidReportTypeNonCodedError";
  }
}
